export enum CollectionNames {
  Clients = 'clients',
  JobTypes = 'job_types',
  Projects = 'projects',
  ProjectJobs = 'jobs',
  Permits = 'permits',
  Settings = 'settings',
  Surveys = 'survey_tasks',
  TimeTracking = 'time_tracking',
  Users = 'users',
  Subdivisions = 'subdivisions',
  Imports = 'imports',
}

export enum OtherCollections {
  Search = 'search',
}
